import {Injectable} from '@angular/core';
import {StageService} from './stage.service';
import {ObjectCheckerService} from './object-checker.service';
import {SizeHelperService} from './size-helper.service';
import {Dimension} from '../custom/Dimension';
import { Subject } from 'rxjs/Subject';

declare let THREE: any;

@Injectable()
export class StairsDimensionService {

  private leftDimension: Dimension;
  private rightDimension: Dimension;
  private stairDimension: Dimension;
  private formatter: (length: number) => string;
  public dimensionConditionChange = new Subject<any>();

  constructor(
    private stage: StageService,
    private objectChkr: ObjectCheckerService,
    sizeHelper: SizeHelperService
  ) {
    this.leftDimension = new Dimension(0x3374A9);
    this.rightDimension = new Dimension(0x3374A9);
    this.stairDimension = new Dimension(0x3374A9);
    this.formatter = (length) => sizeHelper.CMToFTAndINCH(length).replace('\'', '\' ');
    stage.addMany([this.leftDimension, this.rightDimension, this.stairDimension]);
  }

  update(stairs) {
    const {firstPoint, secondPoint, width, height} = stairs.userData.config;
    const start = new THREE.Vector3(firstPoint.x, 0, firstPoint.y);
    const end = new THREE.Vector3(secondPoint.x, 0, secondPoint.y);
    const direction = new THREE.Vector3().subVectors(end, start).normalize();
    const edgeNormal = new THREE.Vector3()
      .subVectors(end, start)
      .applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2)
      .normalize();

    const topStair = stairs.getObjectByName('Top');
    const bottomStair = stairs.getObjectByName('Bottom');
    const dof = new THREE.Vector3().subVectors(start, topStair.position).projectOnVector(edgeNormal);
    const leftStairPoint = topStair.position.clone().add(direction.clone().negate().multiplyScalar(width / 2)).add(dof);
    const rightStairPoint = topStair.position.clone().add(direction.multiplyScalar(width / 2)).add(dof);
    start.y = end.y = leftStairPoint.y = rightStairPoint.y = height;
    start.y -= 10;
    end.y -= 10;
    leftStairPoint.y -= 10;
    rightStairPoint.y -= 10;
    this.leftDimension.update(start, leftStairPoint, this.formatter);

    this.rightDimension.update(rightStairPoint, end, this.formatter);

    const stairDimensionOffset = new THREE.Vector3().subVectors(bottomStair.position, topStair.position);
    //stairDimensionOffset.setLength(stairDimensionOffset.length() / 2);
    stairDimensionOffset.setLength(30);
    this.stairDimension.update(
      leftStairPoint.add(stairDimensionOffset),
      rightStairPoint.add(stairDimensionOffset),
      this.formatter
    );
    this.dimensionConditionChange.next(true);
  }

  hide() {
    this.leftDimension.visible = this.rightDimension.visible = this.stairDimension.visible = false;
    this.dimensionConditionChange.next(false);
  }

  getCentrPosition() {
    if (this.isVisible()) {
      const direction = new THREE.Vector3(this.stairDimension.position.x, this.stairDimension.position.y, this.stairDimension.position.z);
      direction.add(this.stairDimension.children[1].position);
      return direction;
    } else {
      return false;
    }
  }

  isVisible() {
    return this.stairDimension.visible;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/stairs-dimension.service.ts